import styled from 'styled-components';

export const Wrapper = styled.div`
  max-width: 1140px;
  margin: auto;
  padding: ${({ theme }) => theme.spacers.m};
`;
